import { eventProps, trackEvent as globalTrackEvent } from '../utils/analytics';
import { useTypedSelector } from '../store';

export type IEventTracker = (event: string, props?: Partial<Omit<eventProps, 'action'>>) => void;

export const useTrackEvent = () => {
  // Get comprehensive context data from Redux store
  const { originalToken, actionToken, reviews } = useTypedSelector((state) => state.gbpSlice);
  const currentReview = reviews.currentReview;
  const actionTokenData = actionToken.data;

  const trackEvent: IEventTracker = (event, props) => {
    // Build comprehensive context data with required fields using proper field names
    const contextData: eventProps = {
      action: event,
      location: window.location.href,
      
      // GBP Review data (using exact field names from GbpReview interface)
      reviewId: currentReview?.reviewId,
      starRating: currentReview?.starRating,
      reviewerDisplayName: currentReview?.reviewerDisplayName,
      locationId: currentReview?.locationId,
      replyComment: currentReview?.replyComment ? 'true' : 'false',
      createdAt: currentReview?.createdAt,
      
      // ActionToken data (using exact field names from ActionToken interface)
      actionTokenId: actionTokenData?.id,
      actionType: actionTokenData?.actionType,
      accountId: actionTokenData?.accountId,
      targetId: actionTokenData?.targetId,
      managerId: actionTokenData?.managerId || undefined,
      useCount: actionTokenData?.useCount,
      maxUses: actionTokenData?.maxUses,
      expiresAt: actionTokenData?.expiresAt,
      reviewerName: actionTokenData?.context.reviewerName,

      appName: 'review_notifications',
      
      // Business context data,
      originalToken: originalToken || undefined,
      event_timestamp: new Date().toISOString(),
      
      // Environment context
      env: process.env.REACT_APP_BUILD_ENV || undefined,
      
      // Override with any provided props
      ...props
    };

    globalTrackEvent(contextData);
  };

  return { trackEvent };
};
